export const leagueIndex: { [key in string]: string } = {
  ["first-league"]: "100",
  ["second-league"]: "200",
  ["third-league"]: "300",
};

export const testFcmUsers = [
  {
    label: "Никита Г.",
    token:
      "fsMnK49ITE1ksDLTMsPIZD:APA91bG-ZkRjSWGoJ0OoqCyB5kR46GIoUuWA2qKtSjxjD5jyiNdo-6cFHJ77NH8ufGEX8QYGFhQD1tfhtEf6tOt2315JpvMfIhgL9e5Uy5L_-3xLLCIAHI0",
  },
  {
    label: "Андрей Е.",
    token:
      "fQ2DFMlTL0t9oWFUiWHRgw:APA91bGRTzhRGszg9iSRbCkJu1FjdnM5_N0q9sk8Z8MCXK6DM1m9jtZ-S-eyCBGN9--SkYjjrg1YAuVL4EvtF0j9YH3D2QXH6N0hp72_J_hcUPx9cwD3O4Q",
  },
  {
    label: "Дима М.",
    token:
      "cH1Vf_eWYEq9nZ-Xr9zGN6:APA91bER6KUDGi_dqPQ-tIAToXyorc-kefPvgNlPFHQqgG61vC6G39j7Cc4raPWUKvU_oNGXTng-2eOzMYlVJdZEvmXCrXiDpR4h4Frvg3fSARcYmWTv3FY",
  },
  {
    label: "2Dit",
    token:
      "crYU-flrQkmytrYWgonoVa:APA91bFGdfI1N4NuVTFCiO-KaIItCrPD__62ManL2pB83LceKtuEsF44jv5g4Nau85b-Wn6LbaRhCTlBs97o_MZ7kTWv2K0vg2zHCLXnBbC7RrSC3XHuK20",
  },
];
